import throttle from '../../helpers/throttle';
import './styles.css';

class NativeGallery {
  constructor(root, options = {}) {
    this.root = root;
    this.options = options;
    this.slides = Array.from(this.root.querySelectorAll('[data-slide]'));
    this.currentIndex = 0;
    this.count = this.slides.length;
    this.currentImageIndex = 0;
    this.initialize();
  }

  initialize() {
    this.root.classList.add('-loaded');
    const scrollListener = throttle(() => {
      this.currentIndex = Math.round(this.root.scrollLeft / this.root.offsetWidth);
      if (this.options.onScroll) this.options.onScroll();
      this.fireChange();
    }, 100);
    this.root.addEventListener('scroll', scrollListener);
  }

  scrollToIndex(toIndex) {
    this.root.scrollTo(this.root.offsetWidth * toIndex, 0);
  }

  prev = async () => {
    try {
      if (this.currentIndex === 0) return;
      const toIndex = this.currentIndex - 1;
      const prevSlide = this.slides[toIndex];
      this.currentImageIndex -= 1;

      if (prevSlide.tagName === 'IMG') {
        await this.preloadImage(prevSlide);
      } else {
        await this.preloadImage(prevSlide.querySelector('img'));
      }
      this.root.scrollTo(this.root.offsetWidth * toIndex, 0);
    } catch (error) {
      console.error(error);
    }
  };

  next = async () => {
    try {
      if (this.currentIndex === this.count - 1) return;
      const toIndex = this.currentIndex + 1;
      const nextSlide = this.slides[toIndex];
      this.currentImageIndex += 1;

      if (nextSlide.tagName === 'IMG') {
        await this.preloadImage(nextSlide);
      } else {
        await this.preloadImage(nextSlide.querySelector('img'));
      }
      this.root.scrollTo(this.root.offsetWidth * toIndex, 0);
    } catch (error) {
      console.error(error);
    }
  };

  fireChange() {
    const event = new CustomEvent('change', {
      detail: {
        current: this.current,
        count: this.count,
        currentImage: this.currentImage,
      },
    });
    this.root.dispatchEvent(event);
  }

  preloadImage(image) {
    if (image.complete) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      image.setAttribute('loading', 'eager');
      image.addEventListener('load', () => resolve());
      // eslint-disable-next-line prefer-promise-reject-errors
      image.addEventListener('error', () => reject(`can't load image: ${image.src}`));
    });
  }

  get current() {
    return this.currentIndex + 1;
  }
}

export default NativeGallery;
